import { addCourse, updateCourse, authCourseList, queryInvite } from '@/api/course';
import { addProject, updateProject, delProject } from '@/api/project';
import { cache_get, cache_set, cache_remove } from '@/utils/cache';
const state = {
  course: {}, // 课程信息
  project: {}, // 项目信息
  showMenu: true,
  showCourseEdit: 'close',
  showProjectEdit: 'close',
  projectType: {},
  showScenetEdit: 'close', //任务场景
  showPublishVersion: false,
  courseList: [],
  simulationPlatform: ''
};

const actions = {
  async saveCourse({ dispatch }, form) {
    const result = form._id ? await updateCourse(form) : await addCourse(form);
    if (result.code == 200) {
      this.commit('global/SHOW_SNACKBAR', { color: 'green', text: '操作成功' });
      dispatch('refreshCourseList');
      dispatch('reverseShowCourseEdit', 'close');
    }
  },
  async refreshCourseList({ commit, state }, data = {}) {
    let res = null;
    if (JSON.stringify(data) !== '{}') {
      res = await authCourseList({
        currentPage: data.currentPage,
        perPage: data.perPage,
        name: data.name,
        refer: data.refer,
        filterValue: 'Published',
        majorGroup: data.majorGroup,
        majorGroup2: data.majorGroup2,
        is_open: data.is_open,
        createUserId: data.createUserId,
      });
      if (res) {
        data.fn(res);
      }
    } else {
      res = await authCourseList({ currentPage: 1, perPage: 8 });
    } 

    //项目编号排序
    if (res.data && res.data.rows) {
      if (res.data.rows.length > 0) {
        res.data.rows.forEach(item => {
          item.children.sort(function (a, b) {
            if (a.orderNum > b.orderNum) return 1;
            else return -1;
          });
        });
      }
    }

    const curId = window.localStorage.getItem('course_cur_id');
    const course = res.data.rows.find(item => item._id === curId);
    commit('SET_COURSE_LIST', res.data.rows);
  },
  async getQueryInvite({dispatch, commit, state }, data) {
      commit('SET_COURSE_LIST',data);

  },
  async clearCourseList({ commit, state }, data) {
   
    commit('SET_COURSE_LIST', []);
  },
  async setCourseList({ commit }, courseList) {
    commit('SET_COURSE_LIST', courseList);
  },
  async updateCourse({ commit, state }, course) {
    commit('SET_COURSE', course);
    console.log('state.course :>> ', state.course);

    if (course.children && course.children.length > 0) {
      let sectionType = course.sectionType || '';
      let projectData = course.children[0];
      projectData.sectionType = sectionType;

      commit('SET_PROJECT', projectData);
    } else {
      commit('SET_PROJECT', {});
    }
    this.dispatch('task/refreshTaskList');
  },
  async saveProject({ dispatch, state, commit }, form) {
    const result = form._id ? await updateProject(form) : await addProject(form);
    if (result.code == 200) {
      this.commit('global/SHOW_SNACKBAR', { color: 'green', text: '操作成功' });
      let course = Object.assign({}, state.course);
      if (form._id) {
        const projectIndex = course.children.findIndex(item => item._id === form._id);
        course.children[projectIndex] = form;
        if (course.children) {
          course.children &&
            course.children.forEach(item => {
              item.orderNum = parseInt(item.orderNum);
              item.sectionType = course.sectionType || '';
            });
          course.children &&
            course.children.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
        }
      } else {
        if (course.children) {
          course.children &&
            course.children.forEach(item => {
              item.orderNum = parseInt(item.orderNum);
              item.orderNum = parseInt(item.orderNum);
              item.sectionType = course.sectionType || '';
            });
          course.children &&
            course.children.sort(function (a, b) {
              return a.orderNum - b.orderNum;
            });
        }

        course.children = course.children ?? [];
        if (course && course.sectionType) {
          result.data.sectionType = course.sectionType;
        }
        course.children.push(result.data);

        if (course && course.sectionType) {
          let sectionType = course.sectionType || '';
          let projectData = course.children[0];
          projectData.sectionType = sectionType;
          commit('SET_PROJECT', projectData);
        }

        this.dispatch('task/refreshTaskList', result.data);
      }
      commit('SET_COURSE', course);
      dispatch('reverseShowProjectEdit', 'close');
      console.log(state.project, 'stateproject');
    }
  },
  async updateProject({ commit, state }, project) {
    if (project._id === state.project._id) {
      commit('SET_PROJECT', {});
    } else {
      commit('SET_PROJECT', project);
    }
    this.dispatch('task/refreshTaskList', project);
    // this.dispatch('editor/refreshSceneList', state.course._id)
  },
  async updateProjectData({ commit, state }, project) {
    commit('SET_PROJECT', project);
    this.dispatch('task/setTaskCurrentPage', 1);
    this.dispatch('task/refreshTaskList', project);
    // this.dispatch('editor/refreshSceneList', state.course._id)
  },

  //初次进入页面默认拿到选中第一条项目去查对应场景
  async initUpdateProject({ commit, state }, project) {
    commit('SET_PROJECT', project);
    this.dispatch('task/refreshTaskList', project);
    // this.dispatch('editor/refreshSceneList', course)
  },
  async handleShowMenu({ commit }) {
    commit('REVERSE_SHOW_MENU');
  },
  async reverseShowCourseEdit({ commit }, val) {
    commit('REVERSE_SHOW_COURSE', val);
  },
  async reverseShowProjectEdit({ commit }, val) {
    commit('REVERSE_SHOW_PROJECT', val);
  },
  async projectType({ commit }, val) {
    commit('REVERSE_SHOW_PROJECT_TYPE', val);
  },
  //任务场景
  async reverseShowSceneEdit({ commit }, val) {
    commit('REVERSE_SHOW_SCENE', val);
  },
  async reverseShowPublishVersion({ commit }, val) {
    commit('REVERSE_SHOW_PUBLISH_VERSION', val);
  },
  async removeProject({ dispatch, commit, state }, callBackQueryProject) {
    delProject(state.project).then(res => {
      let course = Object.assign({}, state.course);
      const projectIndex = course.children.findIndex(item => item._id === state.project._id);
      course.children.splice(projectIndex, 1);
      commit('SET_COURSE', course);
      cache_remove('project');
      callBackQueryProject(course.children[0]);
      // commit('SET_PROJECT', course.children[0]);
    });
  },
};

const mutations = {
  SET_SIMULATION_PLATFORM(state, status) {
    state.simulationPlatform = status;
  },
  SET_COURSE_CHILDREN_ITEM(state, { index, data }) {
    state.course.children[index] = data;
    cache_set('course', state.course);
  },
  SET_COURSE_LIST(state, courseList) {
    state.courseList = courseList;
  },
  SET_COURSE(state, course) {
    cache_set('course', course);
    cache_set('course_cur_id', course._id);
    state.course = course;
  },
  SET_PROJECT(state, project) {
    cache_set('project', project);
    state.project = project;
  },
  REVERSE_SHOW_MENU(state) {
    state.showMenu = !state.showMenu;
  },
  REVERSE_SHOW_COURSE(state, status) {
    state.showCourseEdit = status;
  },
  REVERSE_SHOW_PROJECT(state, status) {
    state.showProjectEdit = status;
  },
  REVERSE_SHOW_PROJECT_TYPE(state, status) {
    state.projectType = status;
  },
  //任务场景
  REVERSE_SHOW_SCENE(state, status) {
    state.showScenetEdit = status;
    console.log(state.showScenetEdit);
  },
  REVERSE_SHOW_PUBLISH_VERSION(state, status) {
    state.showPublishVersion = status;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
